import { IDisplayedCast } from '../../components/shared/artistCard/artist.interface';
import {
  AutoSuggestData,
  CompositeSearchData,
  ElasticArtist,
  ElasticMovie,
  ElasticTag,
} from '../graphql/api.generated';
import { ISearchResult } from './searchContext/searchContextInterface';

export const mergeSearchQueriesResult = (
  autoSuggestRes: AutoSuggestData,
  searchRes: CompositeSearchData,
): ISearchResult => {
  // Handle search results and auto-suggestions
  let tags = [...searchRes.tags, ...autoSuggestRes.tags] as ElasticTag[];
  let artists = [...searchRes.artists, ...autoSuggestRes.artists] as ElasticArtist[];
  let movies = [
    ...searchRes.titleMatch,
    ...searchRes.contextMatch,
    ...autoSuggestRes.contextMatch,
  ] as ElasticMovie[];
  tags = filteredSearchData(tags);
  artists = filteredSearchData(artists);
  const displayArtist: IDisplayedCast[] = artists.map((artist) => ({
    artist,
    roles: [] as string[],
  }));
  movies = filteredSearchData(movies);
  return { artists: displayArtist, tags, items: movies };
};

const filteredSearchData = <T>(entity: Array<T>): Array<T> => {
  // Filter duplicate search results
  const keys = ['id'];
  const filteredList = entity.filter(
    (
      (s) => (o: any) =>
        ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join('|'))
    )(new Set()),
  );
  return filteredList;
};

export const keyboardLayouts: {
  [key: string]: { alphabet: string[]; number: string[] };
} = {
  english: {
    alphabet: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    number: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  },
  default: {
    alphabet: [
      'ا',
      'ب',
      'پ',
      'ت',
      'ث',
      'ج',
      'چ',
      'ح',
      'خ',
      'د',
      'ذ',
      'ر',
      'ز',
      'ژ',
      'س',
      'ش',
      'ص',
      'ض',
      'ط',
      'ظ',
      'ع',
      'غ',
      'ف',
      'ق',
      'ک',
      'گ',
      'ل',
      'م',
      'ن',
      'و',
      'ه',
      'ی',
    ],
    number: ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'],
  },
};
